import { FC } from "react";
import { WizardProps } from "./wizard.types";
import styles from "./wizard.module.css";
import StepWizard from "react-step-wizard";

const Wizard: FC<WizardProps> = ({ children, ...props }) => {
  return (
    <StepWizard
      className={styles.stepWizard}
      transitions={{
        enterRight: `${styles.animated} ${styles.fadeInRight}`,
        enterLeft: `${styles.animated} ${styles.fadeInLeft}`,
        exitRight: `${styles.animated} ${styles.fadeOutRight}`,
        exitLeft: `${styles.animated} ${styles.fadeOutLeft}`,
      }}
      {...props}
    >
      {children}
    </StepWizard>
  );
};

export { Wizard };
